import { ReactComponent as SvgSearch } from '@img/icons/search.svg';
import { locations } from '@redux/slices/locations';
import { useAppDispatch } from '@redux/store';
import Button from '@stories/Components/Button/Button';
import * as React from 'react';
import S from './FilterFull.styles';
const FilterFull = (props) => {
    const refFilters = React.useRef(null);
    const [locationRaw, setLocationRaw] = React.useState(props.params.location);
    const [rangesOthersExpanded, setRangesOthersExpanded] = React.useState(false);
    const [rangesOthersRaw, setRangesOthersRaw] = React.useState(props.params.rangesOthers);
    const [rangesSlidingExpanded, setRangesSlidingExpanded] = React.useState(false);
    const [rangesSlidingRaw, setRangesSlidingRaw] = React.useState(props.params.rangesSliding);
    const [typesRaw, setTypesRaw] = React.useState(props.params.types);
    const typesDisplay = typesRaw.length
        ? props.types.reduce((text, value, i) => value.id !== props.slidingWardrobesId && typesRaw.includes(value.id)
            ? text + (!text ? '' : i < typesRaw.length - 1 ? ', ' : ' or ') + value.text
            : text, '')
        : null;
    const dispatch = useAppDispatch();
    const nonSlidingTypeSelected = typesRaw.some((item) => item !== props.slidingWardrobesId);
    const slidingTypeSelected = typesRaw.some((item) => item === props.slidingWardrobesId);
    React.useEffect(() => {
        props.onChange({
            location: locationRaw,
            types: typesRaw,
        });
    }, [typesRaw, locationRaw]);
    return (React.createElement(S.Container, null,
        React.createElement(S.Form, { onSubmit: (event) => {
                event.preventDefault();
                // Update filter.
                props.onSubmit({
                    location: locationRaw,
                    rangesOthers: rangesOthersRaw,
                    rangesSliding: rangesSlidingRaw,
                    types: typesRaw,
                });
                props.scrollTop();
                // Hide expanded filter.
                dispatch(locations.actions.toggleFilter(false));
            } },
            React.createElement(S.InputWrapper, null,
                React.createElement(S.Input, { id: "location", name: "location", placeholder: "Enter postcode", type: "search", value: locationRaw, onChange: handleLocationChange }),
                React.createElement(S.SubmitButton, null,
                    React.createElement(SvgSearch, null))),
            React.createElement(S.FilterGroup, { ref: refFilters },
                React.createElement(S.FilterTitle, null, "Select the products you would like to see"),
                React.createElement(S.FilterList, { "data-dir": "horizontal" }, props.types.map((option) => (React.createElement(S.FilterItem, { key: option.id },
                    React.createElement("input", { id: `type-${option.id}`, checked: typesRaw.includes(option.id), name: "type", type: "checkbox", value: option.id, onChange: handleTypesChange }),
                    React.createElement("label", { htmlFor: `type-${option.id}` }, option.text)))))),
            props.rangesOthers.length || props.rangesSlidingWardrobes.length ? (React.createElement(React.Fragment, null,
                React.createElement(S.Divider, null),
                React.createElement(S.FilterWrapper, null,
                    props.rangesOthers.length ? (React.createElement(React.Fragment, null,
                        React.createElement(S.FilterTitle, { "data-expanded": nonSlidingTypeSelected && rangesOthersExpanded, disabled: !nonSlidingTypeSelected, onClick: (event) => {
                                event.preventDefault();
                                if (nonSlidingTypeSelected) {
                                    setRangesOthersExpanded(!rangesOthersExpanded);
                                }
                            } },
                            !typesDisplay
                                ? 'Fitted wardrobes, Fitted Living, Home office, or Understairs'
                                : typesDisplay,
                            React.createElement(S.FilterGroupToggleIcon, null)),
                        React.createElement(S.FilterGroup, { "data-accordion": true, "data-expanded": nonSlidingTypeSelected && rangesOthersExpanded, disabled: !nonSlidingTypeSelected },
                            React.createElement(S.FilterGroupBody, null,
                                React.createElement(S.FilterAll, null,
                                    React.createElement(S.FilterItem, null,
                                        React.createElement("input", { id: `ranges-others-all`, checked: rangesOthersRaw.length === 0, name: "type", type: "checkbox", onChange: handleRangesOthersAllChange }),
                                        React.createElement("label", { htmlFor: `ranges-others-all` }, "Any Hammonds Range"))),
                                React.createElement(S.FilterSubtitle, null, "Select Ranges:"),
                                React.createElement(S.FilterList, { "data-dir": "vertical" }, props.rangesOthers.map((option) => (React.createElement(S.FilterItem, { key: option.id },
                                    React.createElement("input", { id: `ranges-others-${option.id}`, checked: rangesOthersRaw.includes(option.id), name: "type", type: "checkbox", value: option.id, onChange: handleRangesOthersChange }),
                                    React.createElement("label", { htmlFor: `ranges-others-${option.id}` }, option.text))))))))) : null,
                    props.rangesSlidingWardrobes.length ? (React.createElement(React.Fragment, null,
                        React.createElement(S.FilterTitle, { "data-expanded": slidingTypeSelected && rangesSlidingExpanded, disabled: !slidingTypeSelected, onClick: (event) => {
                                event.preventDefault();
                                if (slidingTypeSelected) {
                                    setRangesSlidingExpanded(!rangesSlidingExpanded);
                                }
                            } },
                            "Sliding wardrobes",
                            React.createElement(S.FilterGroupToggleIcon, null)),
                        React.createElement(S.FilterGroup, { "data-accordion": true, "data-expanded": slidingTypeSelected && rangesSlidingExpanded, disabled: !slidingTypeSelected },
                            React.createElement(S.FilterGroupBody, null,
                                React.createElement(S.FilterAll, null,
                                    React.createElement(S.FilterItem, null,
                                        React.createElement("input", { id: `ranges-sliding-all`, checked: rangesSlidingRaw.length === 0, name: "type", type: "checkbox", onChange: handleRangesSlidingAllChange }),
                                        React.createElement("label", { htmlFor: `ranges-sliding-all` }, "Any Hammonds Range"))),
                                React.createElement(S.FilterSubtitle, null, "Select Ranges:"),
                                React.createElement(S.FilterList, { "data-dir": "vertical" }, props.rangesSlidingWardrobes.map((option) => (React.createElement(S.FilterItem, { key: option.id },
                                    React.createElement("input", { id: `ranges-sliding-wardrobes-${option.id}`, checked: rangesSlidingRaw.includes(option.id), name: "type", type: "checkbox", value: option.id, onChange: handleRangesSlidingChange }),
                                    React.createElement("label", { htmlFor: `ranges-sliding-wardrobes-${option.id}` }, option.text))))))))) : null))) : null,
            React.createElement(S.Divider, null),
            React.createElement(S.SubmitWrapper, null,
                React.createElement(Button, { buttonType: "default", type: "submit" }, "Find Your Nearest Showroom")))));
    function handleLocationChange(event) {
        setLocationRaw(event.target.value);
    }
    function handleTypesChange(event) {
        const value = event.target.value;
        const typesSet = new Set(typesRaw);
        if (typesSet.has(value)) {
            typesSet.delete(value);
        }
        else {
            typesSet.add(value);
        }
        // Convert set to array.
        const newTypes = [...typesSet];
        // Clear sliding wardrobes ranges if not selected anymore.
        if (newTypes.every((item) => item !== props.slidingWardrobesId)) {
            setRangesSlidingRaw([]);
        }
        // Clear non-sliding wardrobes ranges if not selected anymore.
        if (newTypes.every((item) => item === props.slidingWardrobesId)) {
            setRangesOthersRaw([]);
        }
        // Update types.
        setTypesRaw(newTypes);
        if (newTypes.length === 0) {
            return;
        }
        // Scroll to top of filters.
        refFilters.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start',
        });
    }
    function handleRangesOthersChange(event) {
        const set = new Set(rangesOthersRaw);
        const value = event.target.value;
        if (set.has(value)) {
            set.delete(value);
        }
        else {
            set.add(value);
        }
        setRangesOthersRaw([...set]);
    }
    function handleRangesOthersAllChange() {
        if (rangesOthersRaw.length === 0) {
            return;
        }
        setRangesOthersRaw([]);
    }
    function handleRangesSlidingChange(event) {
        const set = new Set(rangesSlidingRaw);
        const value = event.target.value;
        if (set.has(value)) {
            set.delete(value);
        }
        else {
            set.add(value);
        }
        setRangesSlidingRaw([...set]);
    }
    function handleRangesSlidingAllChange() {
        if (rangesSlidingRaw.length === 0) {
            return;
        }
        setRangesSlidingRaw([]);
    }
};
export default FilterFull;
